export default __webpack_public_path__ + "_/_/node_modules/ui-header/src/images/lc-logo-white-5c3e3a9e80c31a8502322e9d636ca784.svg";